import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { setupHttpInterceptor } from "./lib/http-interceptor";

// Setup HTTP interceptor to automatically handle 401 responses
setupHttpInterceptor();

createRoot(document.getElementById("root")!).render(<App />);
